import '../lib_shim.js';
import '../../js_src/js/external/hammer.min.js';
import '../../js_src/js/external/velocity.including.ui.min.js';
import '../../js_src/js/external/jquery.autocomplete.js';
import '../../js_src/js/basics.js';
import '../../js_src/js/mobile.js';
import '../../js_src/js/ycomponent/collapsebox/collapsebox.js';
import '../../js_src/js/ycomponent/banner/banner.js';
import '../../js_src/js/ycomponent/campaigns/campaigns.js';
import '../../js_src/js/shared/external_link.js';
import '../../js_src/js/shared/header_menu.js';
import '../../js_src/js/shared/web_components/plp.js';
import '../../js_src/js/shared/web_components/button.js';
import '../../js_src/js/shared/web_components/link_button.js';
import '../../js_src/js/shared/web_components/badge.js';
import '../../js_src/js/shared/web_components/chip.js';
import '../../js_src/js/shared/web_components/checkbox.js';
import '../../js_src/js/shared/web_components/switch_toggle.js';
import '../../js_src/js/shared/web_components/dialog.js';
import '../../js_src/js/shared/web_components/radio_group.js';
import '../../js_src/js/shared/web_components/radio_option.js';
import '../../js_src/js/shared/web_components/tabs.js';
import '../../js_src/js/shared/web_components/avatar.js';
import '../../js_src/js/shared/web_components/avatar_group.js';
import '../../js_src/js/shared/web_components/inline_message.js';
import '../../js_src/js/shared/web_components/divider.js';
import '../../js_src/js/shared/web_components/step_indicator.js';
import '../../js_src/js/shared/web_components/input_field.js';
import '../../js_src/js/shared/web_components/textarea.js';
import '../../js_src/js/shared/web_components/tooltip.js';
import '../../js_src/js/shared/web_components/dropdown_item.js';
import '../../js_src/js/shared/web_components/dropdown.js';